module.exports = __webpack_public_path__ + "img/valizo_logo.f7f3a7f7.jpg";